import {Component, model, OnDestroy} from "@angular/core";
import {FormBuilder, FormGroup, ReactiveFormsModule} from "@angular/forms";
import {Subscription} from "rxjs";
import {HttpErrorResponse} from "@angular/common/http";
import {AlertService} from "../../../common/alert/alert.service";
import {AlertComponent} from "../../../common/alert/alert.component";
import {NgIf} from "@angular/common";
import {PinholeUser, PinholeUserService} from "../services/pinhole.user.service";

@Component({
    selector: 'change-login',
    templateUrl: './change-login.component.html',
    imports: [
        ReactiveFormsModule,
        AlertComponent,
        NgIf
    ],
    providers: [AlertService],
})
export class ChangeLoginComponent implements OnDestroy {
    private formBuilder = new FormBuilder().nonNullable
    private login = this.formBuilder.control("")
    private subscriptions: Subscription[] = [];
    readonly user = model.required<PinholeUser | null>()

    isLoading: boolean = false;
    changeLoginForm = new FormGroup({
        login: this.login,
    });

    constructor(private pinholeUserService: PinholeUserService, private alertService: AlertService) {
    }

    ngOnDestroy(): void {
        this.subscriptions.forEach(s => s.unsubscribe())
    }

    changeLogin() {
        this.isLoading = true;
        this.subscriptions.push(
            this.pinholeUserService
                .changeLogin({
                    iid: this.user()!.iid,
                    newLogin: this.login.value
                })
                .subscribe({
                    next: (value) => {
                        this.alertService.showAlert("success", "Login changed", null);
                        this.isLoading = false;
                        if (value != null) {
                            this.user.set(value);
                        }
                    },
                    error: (_: HttpErrorResponse) => {
                        this.alertService.showAlert("danger", "Failed to change login", null);
                        this.isLoading = false;
                    }
                })
        );
    }
}